import { type Component, createResource, For, type Resource, Show } from "solid-js";
import StarIcon from "~/Icons/startIcon.svg?component-solid";
import { CustomImage } from "~/solidJs/shared/ui";
import { ProductsApi } from "../../shared/api/ProductsApi";

type PricingFeedBackEntityProps = {
	feedBackResource: Resource<Awaited<ReturnType<typeof ProductsApi.getPricingFeedBackData>>>;
};
export const PricingFeedBackEntity: Component<PricingFeedBackEntityProps> = (props) => {
	return (
		<div class="flex w-full justify-center gap-4 overflow-x-auto">
			<For each={props.feedBackResource()}>
				{(feedBackItem) => (
					<div class="flex h-max w-[32%] flex-col items-start justify-start gap-6 rounded-xl bg-[#F3F4F6] p-4">
						<div class="text-sm">{feedBackItem.feedBack}</div>
						<div class="flex gap-2">
							<For each={Array.from({ length: 5 })}>
								{() => <StarIcon class="size-4" />}
							</For>
						</div>
						<div class="flex w-full justify-start gap-4">
							<CustomImage
								src={feedBackItem.userPick}
								containerClassName="max-w-[60px] max-h-[60px]"
								style={{ "border-radius": "999px" }}
							/>
							<div class="flex flex-col justify-center">
								<h2 class="m-0 font-semibold text-sm">{feedBackItem.name}</h2>
								<div class="text-gray-400 text-xs">{feedBackItem.position}</div>
							</div>
						</div>
					</div>
				)}
			</For>
		</div>
	);
};
type PricingFeedBackLogoSectionProps = Record<string, never>;
export const PricingFeedBackLogoSection: Component<PricingFeedBackLogoSectionProps> = (_props) => {
	const [feedBackResource] = createResource(ProductsApi.getPricingFeedBackData);

	return (
		<section class="flex w-full flex-col items-center justify-center gap-6 rounded-xl">
			<h1 class="m-0 font-semibold text-3xl">Comments and Reviews</h1>
			<Show when={feedBackResource} keyed>
				{(resolvedFeedBackResource) => (
					<PricingFeedBackEntity feedBackResource={resolvedFeedBackResource} />
				)}
			</Show>
		</section>
	);
};
